
export class HallOfFameVO {
    public id: number = 0;
    public rang: number = 0;
    public name: string;
    public points: number = 0;
}
